export default __webpack_public_path__ + "static/N0142-104f2f228ac581269779dd899c07bec3.png";